export default {
    SET_ROUTE (state, route) {
        state.route = route;
    },
    SET_DRAWER (state, drawer) {
        state.drawer = drawer
    },
    SET_LOADING (state, loading) {
        state.loading = loading
    },
    SET_PAGE_LOADING (state, page_loading) {
        state.page_loading = page_loading
    },
    SET_USER (state, user) {
        state.user = user
    },
    SET_ALERT (state, alert) {
        state.alert = alert
    },
    SET_AUTHORIZATION (state, authorization) {
        state.authorization = authorization
    },
    SET_MAILS (state, mails) {
        state.mails = mails
    },
    SET_UNREAD (state, unread) {
        state.unread = unread
    }
}
